// Module
var code = "<wf-affect-list-history affect-list=\"affectList\" options=\"options\" selected=\"selected\"></wf-affect-list-history> ";
// Exports
export default code;